konnyScript(function($){
  
    $('[id^=\'crmain_swiper_slide\']').each(function(index){
        index = index+1;
        var mainSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed:0,
            autoplay:{
                delay:1000,
                disableOnInteraction:false,
            },
        });
    });

    fade();

    $(window).scroll(function () {
        fade();
    });
    
     
    function fade() {
        $(".fade").each(function () {
            var objectTop = $(this).offset().top;
            var windowBottom = $(window).scrollTop() + $(window).innerHeight();
            if (objectTop < windowBottom) {
                $(this).css({
                    transition:'0.5s linear 0s',
                    opacity: 1,
                    top:'0px',
                });
            } else {
                $(this).css({
                    opacity: 0,
                    top:'30px',
                });
            }
        });


        $(".fadeWrap").each(function () {
            var objectTop = $(this).offset().top;
            var windowBottom = $(window).scrollTop() + $(window).innerHeight();
            if (objectTop < windowBottom) {
                $(this).children('.fade01').css({
                    transition:'0.5s linear 0s',
                    opacity: 1,
                    top:'0px',
                });
                $(this).children('.fade02').css({
                    transition:'0.5s linear 0.5s',
                    opacity: 1,
                    top:'0px',
                });
                $(this).children('.fade03').css({
                    transition:'0.5s linear 1s',
                    opacity: 1,
                    top:'0px',
                });
                $(this).children('.fade04').css({
                    transition:'0.5s linear 1.5s',
                    opacity: 1,
                    top:'0px',
                });
                $(this).children('.fade05').css({
                    transition:'0.5s linear 2s',
                    opacity: 1,
                    top:'0px',
                });
            } else {
                $(this).children('p').css({
                    opacity: 0,
                    top:'30px',
                });
                $(this).children('div').css({
                    opacity: 0,
                    top:'30px',
                });
            }
        });
    };

    
    if($('#hipConBox1').length){
    
        var hipLine01 = $('#hipConBox1').offset();
        var hipLine02 = $('#hipConBox2').offset();
        var hipLineHeight = $('#hipConBox2').height();
        var vHeight=$(window).height();
        
        var hipLinePar01= parseInt(hipLine01.top - vHeight/2);
        var hipLinePar02 = parseInt(hipLine02.top - vHeight/2);
        var hipLinePar03 = parseInt(hipLine02.top + hipLineHeight);
        
        if($(document).scrollTop() > hipLinePar03){
            $('.bcpWrap .conWrap01 .hipConBox .hipLine').removeClass('on');
        }else if($(document).scrollTop() > hipLinePar02){
                if($('.bcpWrap .conWrap01 .hipLine01').hasClass("on")){
                    $('.bcpWrap .conWrap01 .hipLine02').css('transition-delay','0s').addClass('on');
                    $('.bcpWrap .conWrap01 .hipLine03').css('transition-delay','0.8s').addClass('on');
                }else{
                    $('.bcpWrap .conWrap01 .hipLine01').css('transition-delay','0s').addClass('on');
                    $('.bcpWrap .conWrap01 .hipLine02').css('transition-delay','0.8s').addClass('on');
                    $('.bcpWrap .conWrap01 .hipLine03').css('transition-delay','1.6s').addClass('on');
                }
        }else if($(document).scrollTop() > hipLinePar01){
            $('.bcpWrap .conWrap01 .hipLine00').addClass('on');
            
            $('.bcpWrap .conWrap01 .hipLine01').addClass('on');
            $('.bcpWrap .conWrap01 .hipLine02').css('transition-delay','0.8s').removeClass('on');
            $('.bcpWrap .conWrap01 .hipLine03').css('transition-delay','0s').removeClass('on');
        }else{
            $('.bcpWrap .conWrap01 .hipLine').removeClass('on');
        }
    }
    
    $(window).scroll(function(){
      if($('#hipConBox1').length){
        var hipLine01 = $('#hipConBox1').offset();
        var hipLine02 = $('#hipConBox2').offset();
        var hipLineHeight = $('#hipConBox2').height();
        var hipLinePar01= parseInt(hipLine01.top - vHeight/2);
        var hipLinePar02 = parseInt(hipLine02.top - vHeight/2);
        var hipLinePar03 = parseInt(hipLine02.top + hipLineHeight);
        if($(document).scrollTop() > hipLinePar02){
            if($('.bcpWrap .conWrap01 .hipLine01').hasClass("on")){
            	$('.bcpWrap .conWrap01 .hipLine02').css('transition-delay','0s').addClass('on');
            	$('.bcpWrap .conWrap01 .hipLine03').css('transition-delay','0.8s').addClass('on');
            }else{
            	$('.bcpWrap .conWrap01 .hipLine01').addClass('on');
            	$('.bcpWrap .conWrap01 .hipLine02').css('transition-delay','0.8s').addClass('on');
            	$('.bcpWrap .conWrap01 .hipLine03').css('transition-delay','1.6s').addClass('on');
            }
        }else if($(document).scrollTop() > hipLinePar01){
            if($('.bcpWrap .conWrap01 .hipLine00').hasClass("on") === false){
            	$('.bcpWrap .conWrap01 .hipLine00').addClass('on');
            }
            if($('.bcpWrap .conWrap01 .hipLine01').hasClass("on") === false){
            	$('.bcpWrap .conWrap01 .hipLine01').addClass('on');
            }
        }
      }
    });
    
  $('.bcpWrap .conBoxWrap01 .conBox').click(function(){
    if($(this).hasClass('on')){
      $(this).removeClass('on');
      $('body').removeClass('scrollDisable');
      $('body').off('scroll touchmove mousewheel');
      console.log('scrollAble 실행');
      if($('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').hasClass('on')){
        $('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').removeClass('on');
      }else{
        $('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').addClass('on');
      }
    }else{
      $(this).addClass('on');
      $('body').addClass('scrollDisable');
      $('body').on('scroll touchmove mousewheel', function(e){
          e.preventDefault();
      });
      console.log('scrollDisable 실행');
      if($('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').hasClass('on')){
        $('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').removeClass('on');
      }else{
        $('#shopify-section-template--17378428944560__custom_liquid_R6xcg4').addClass('on');
      }
    }
  });

  $('.bcpWrap .conBoxWrap01 .conBox.on .conLayer').on('scroll touchmove mousewheel', function(e){
      e.preventDefault();
  });

    $('.bcpWrap .notiConTop').click(function(){
        var notiCon = $(this).parents('.notiConBox');
        notiCon.toggleClass('on');
    });
   
  var swiper = new Swiper("#logo_swiper_slide1", {
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
        },
        speed:20000,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 'auto',
    });

    $('[id^=\'w_fade_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#w_fade_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#w_fade_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#w_fade_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#w_fade_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#w_fade_swiper_slide'+index+' .swiper-button-prev';
        var gifSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            //mousewheel: true,
            effect:'fade',
            speed:300,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            /*
            on: {
                reachEnd: function () {
                    gifSlide.mousewheel.disable();
                },
            },
            */
        });
        /*
        window.addEventListener('wheel', function (event) {
            if (event.deltaY < 0) {
                gifSlide.mousewheel.enable();
            } else if (event.deltaY > 0) {
            }
        });
        */
    });
    
    $('[id^=\'gif_swiper_slide\']').each(function(index){
        index = index+1;
        var gifSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            centeredSlides:true,
            loop:true,
            effect:'fade',
            speed:400,
            autoplay:{
                delay:800,
                disableOnInteraction:false,
            },
        });
    });

  
    $('[id^=\'baby_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#baby_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#baby_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#baby_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#baby_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#baby_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:1.2,
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: true,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 'auto', 
                    spaceBetween: 20,
                },
            },
        });
    });
  
    $('[id^=\'w3_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#w3_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#w3_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#w3_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#w3_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#w3_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:3,
            slidesPerGroup:1,
            spaceBetween:20,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: true,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
        });
    });


  $('section[id$="666eb8fc8bde"] .swiper').each(function(){
    $(this).removeClass('swiper');
    $(this).removeClass('carousel');
  })
  
  $('section[id$="666eb8fc8bde"] .swiper-wrapper').each(function(){
    $(this).removeClass('swiper-wrapper');
    $(this).removeClass('carousel__wrapper');
  })
    
  $('section[id$="666eb8fc8bde"] .swiper-slide').each(function(){
    $(this).removeClass('swiper-slide');
    $(this).removeClass('carousel_slide');
  })
  
  $('section[id$="ec80dbc3204a"] .swiper').each(function(){
    $(this).removeClass('swiper');
    $(this).removeClass('carousel');
  })

  $('section[id$="ec80dbc3204a"] .swiper-wrapper').each(function(){
    $(this).removeClass('swiper-wrapper');
    $(this).removeClass('carousel__wrapper');
  })
  $('section[id$="ec80dbc3204a"] .swiper-slide').each(function(){
    $(this).removeClass('swiper-slide');
    $(this).removeClass('carousel_slide');
  })
});